import { formatNumbers } from 'core/helpers/format-numbers'
import { adminService } from 'core/services/adminService'
import { useState } from 'react'

import c from './assets/sass/case-item.module.scss'

export const CaseItem = ({ caseData, onEdit, onUpdate }) => {
    const [loading, setLoading] = useState(false)

    const toggleActive = async () => {
        try {
            setLoading(true)
            await adminService.updateCase(caseData.id, {
                name: caseData.name,
                description: caseData.description,
                price: caseData.price,
                imageUrl: caseData.imageUrl,
                maxPromoCodes: caseData.maxPromoCodes,
                dailyPurchaseLimit: caseData.dailyPurchaseLimit,
                category: caseData.category || 'STANDOFF_2',
                isActive: !caseData.isActive,
            })
            onUpdate()
        } catch (error) {
            alert('Ошибка: ' + error.message)
        } finally {
            setLoading(false)
        }
    }
    
    const categoryLabel = caseData.category === 'PUBG_MOBILE' ? 'PUBG Mobile' : 'Standoff 2'

    return (
        <div className={c.component}>
            <img
                src={caseData.imageUrl || '/images/case-01.png'}
                alt={caseData.name}
                className={c.image}
            />
            <div className={c.info}>
                <span className={c.name}>{caseData.name}</span>
                <span className={c.category} style={{ 
                    color: caseData.category === 'PUBG_MOBILE' ? '#F7B231' : '#FF4A2A',
                    fontSize: '11px',
                    fontWeight: '600'
                }}>
                    {categoryLabel}
                </span>
                <span className={c.price}>
                    {formatNumbers(parseInt(caseData.price))} монет
                </span>
                <span className={c.codes}>
                    Промокоды: {caseData.available}/{caseData.total} | Куплено:{' '}
                    {caseData.purchased}
                </span>
                <span className={c.limit}>
                    Лимит в день: {caseData.dailyPurchaseLimit || 5} шт
                </span>
            </div>
            <div className={c.actions}>
                <button className={c.btn} onClick={onEdit}>
                    Редактировать
                </button>
                <button
                    className={`${c.btn} ${caseData.isActive ? c.btnDanger : c.btnSuccess}`}
                    onClick={toggleActive}
                    disabled={loading}
                >
                    {caseData.isActive ? 'Выключить' : 'Включить'}
                </button>
            </div>
        </div>
    )
}
